import { deleteFromStorage } from '@rehooks/local-storage';

export function clearDeprecatedLocalStorage() {
  deleteFromStorage('accessToken');
  deleteFromStorage('userRoles');
  deleteFromStorage('accessKeys');
}

export function clearLocalStorage() {
  clearDeprecatedLocalStorage();
  deleteFromStorage('chirpAccessToken');
  deleteFromStorage('acceptedTermsAt');
}
